<template>
    <el-select class="organisation-select"
               v-model="organisationId"
               filterable remote
               default-first-option
               :loading="loading"
               :loading-text="`${$t('loading')}...`"
               :no-data-text="$t('no_data')"
               :placeholder="$t('search')"
               :remote-method="loadOptions">
        <el-option v-for="organisation in organisations"
                   :key="organisation.OrganisationId"
                   :label="getLabel(organisation)"
                   :value="organisation.OrganisationId.toString()" />
        <el-option disabled :value="null" :label="$t('no_match_found')" v-if="query && !organisations.length" class="no-data"/>
        <el-option value="" v-if="query"><el-button type="secondary" @click.stop="createOrganisation"><i class="md-icon">add</i>{{ $t('create') }} {{ $t('terms.organisation') }}</el-button></el-option>
    </el-select>
</template>

<script lang="ts">
    import Vue from 'vue';

    import { Organisation, OrganisationProvider } from '@/utilities/api/organisations';

    export default Vue.extend({
        name: 'organisation-select',
        props: {
            value: Number,
        },
        data() {
            return {
                query: '',
                loading: false,
                organisations: [] as Organisation[],
            }
        },
        computed: {
            organisationId: {
                get(): string { return this.value ? this.value.toString() : ''; },
                set(value: string) { this.$emit('input', +value || 0); }
            }
        },
        watch: {
            value: {
                immediate: true,
                async handler() {
                    if (this.value && !this.organisations.find(o => o.OrganisationId == this.value)) {
                        this.organisations.push(await OrganisationProvider.get(this.value));
                    }
                }
            }
        },
        methods: {
            async loadOptions(query: string) {
                this.loading = true,
                    this.organisations = await OrganisationProvider.search(query);
                this.loading = false;
                this.query = query;
            },
            getLabel(organisation: Organisation) {
                return organisation.OrganisationDivisionName ? `${organisation.OrganisationName} - ${organisation.OrganisationDivisionName}` : organisation.OrganisationName;
            },
            createOrganisation() {
                this.$router.push({
                    path: '/outlook/organisation/create', query: {
                    name: this.query,
                    domain: this.getDefaultDomain(),
                    returnTo: this.$route.fullPath,
                }});
            },
            getDefaultDomain() {
                if (this.$route.query.domain) {
                    return this.$route.query.domain.toString();
                }
                if (this.$route.query.email) {
                    return this.$route.query.email.toString().split('@')[1] || '';
                }
                return '';
            },
        }
    });

</script>


<style scoped lang="scss">

    .no-data {
        text-align: center;
        cursor: default;
    }

</style>